// extracted by mini-css-extract-plugin
export default {"container":"PageNotFound_container__yuMxd","innerContainer":"PageNotFound_innerContainer__Z7kgE","texts":"PageNotFound_texts__w4Ljv"};